'use client';

import useInstallPrompt from '@alltrails/install-prompt/hooks/useInstallPrompt';
import InstallBanner from '@alltrails/install-prompt/components/InstallBanner';

type HomeInstallPromptProps = {
  isBot: boolean;
};

const HomeInstallPrompt = ({ isBot }: HomeInstallPromptProps) => {
  const [isBannerOpen, setIsBannerOpen] = useInstallPrompt('banner', !isBot);

  if (isBot) {
    return null;
  }

  return (
    <InstallBanner
      isOpen={isBannerOpen}
      onRequestClose={() => setIsBannerOpen(false)}
      promptLocation="home page"
    />
  );
};

export default HomeInstallPrompt;

